import { render, staticRenderFns } from "./manchestore-compare-slider.vue?vue&type=template&id=240d537e&scoped=true&"
import script from "./manchestore-compare-slider.vue?vue&type=script&lang=js&"
export * from "./manchestore-compare-slider.vue?vue&type=script&lang=js&"
import style0 from "./manchestore-compare-slider.vue?vue&type=style&index=0&id=240d537e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d537e",
  null
  
)

export default component.exports